import { Generico, IUsuarioIsolve } from '@/interfaces'
import { AttaService } from '@/services/attaService'

interface UserRequest {
    id: number
    request: Promise<Generico.IApiResponse<IUsuarioIsolve>>
}

let ____users = new Array<IUsuarioIsolve>()
let ____requests = new Array<UserRequest>()

export async function getUser(userId: number) {
    const requestMadded = ____requests.find(c => c.id == userId)

    if (requestMadded) {
        const response = await requestMadded.request
        if (!response.error) {
            user = response.result
            return user
        }
    }

    var user = ____users.find(c => c.id == userId)

    if (user) return user

    var request = AttaService.getUsuarioById(userId)
    const requestIndex = ____requests.push({
        id: userId,
        request: request
    })

    const response = await request

    if (!response.error) {
        user = response.result
        ____users.push(user)
        ____requests.splice(requestIndex, 1)
    }

    return user
}

export async function getUserName(userId: number) {
    var user = await getUser(userId)
    return user?.nome
}

export async function getUserEmail(userId: number) {
    var user = await getUser(userId)
    return user?.email
}
